import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="onboarding--signing-forms"
export default class extends Controller {
  static targets = ["formDocument", "submitButton", "acceptTerms"];

  connect() {
    this.validate();
  }
  validate = () => {
    if (this.hasAcceptedTerms) {
      this.enableSubmitButton();
    } else {
      this.disableSubmitButton();
    }
  };

  acceptTerms = () => {
    this.acceptTermsTarget.checked = true;
    this.validate();
  };

  acceptTermsTargetConnected = (element) => {
    this.validate();
    element.addEventListener("change", this.validate);
  };

  formDocumentTargetConnected = (element) => {
    this.validate();
    element.addEventListener("turbo:frame-load", this.validate);
  };

  formDocumentTargetDisconnected = (element) => {
    element.removeEventListener("turbo:frame-load", this.validate);
  };

  get formsAreValid() {
    // TODO: Temporary. Remove when updated functionality is implemented so that
    //   some forms can be optional.
    // return !this.hasIncompleteForm;
    return true;
  }

  get hasAcceptedTerms() {
    if (!this.hasAcceptTermsTarget) {
      return true;
    }
    return this.acceptTermsTarget.checked;
  }

  get hasIncompleteForm() {
    return this.formDocumentTargets.some((formDocument) => formDocument.dataset.completed !== "true");
  }

  enableSubmitButton = () => {
    this.submitButtonTarget.disabled = false;
    this.submitButtonTarget.classList.remove("btn-disabled");
  };

  disableSubmitButton = () => {
    this.submitButtonTarget.disabled = true;
    this.submitButtonTarget.classList.add("btn-disabled");
  };
}
